export const PRODUCT_TYPE = {
  ONETIME: 'onetime',
  SUBSCRIBE: 'subscribe'
};

export const NEXT_STEP = {
  SUBSCRIPTION_BUILDER: 'subscription_builder',
  ADD_TO_CART: 'add_to_cart'
};

export const CONTEXT = {
  COFFEE: 'coffee',
  GENERIC_PRODUCT: 'product',
  MACHINE: 'machine'
};

export const COST_PER_ITEM_TAGS = {
  CAPSULE: 'capsules-per-box',
  FRESH_PACKS: 'fresh-packs-per-box',
  DRINKS: 'drinks-per-box'
};
